import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useParams } from 'react-router-dom';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import Header from './components/Header';
import Footer from './components/Footer';
import AdminSidebar from './components/AdminSidebar';
import Home from './pages/Home';
import Books from './pages/Books';
import BookDetail from './pages/BookDetail';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import Information from './pages/Information';
import Login from './pages/Login';
import HubungiKami from './pages/HubungiKami';
import TentangKami from './pages/TentangKami';
import FAQ from './pages/FAQ';
import AdminDashboard from './pages/admin/AdminDashboard';
import BookManagement from './pages/admin/BookManagement';
import NewsManagement from './pages/admin/NewsManagement';
import InformationManagement from './pages/admin/InformationManagement';
import ManajemenTentangKami from './pages/admin/ManajemenTentangKami';
import ManajemenFAQ from './pages/admin/ManajemenFAQ';
import ManajemenSupportLogo from './pages/admin/ManajemenSupportLogo';

const PublicLayout = ({ children }) => (
  <div className="min-h-screen bg-gray-50 flex flex-col">
    <Header />
    <main className="flex-grow">{children}</main>
    <Footer />
  </div>
);

const NewsPageWrapper = () => {
  const { category } = useParams();
  return (
    <News category={category ? category.replace(/-/g, ' ') : null} />
  );
};

const AdminLayout = ({ children }) => {
  const { user } = useSelector((state) => state.auth);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setIsSidebarOpen(false);

  return (
    <div className="min-h-screen bg-gray-50">
      <AdminSidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} closeSidebar={closeSidebar} />
      
      <div className="lg:ml-64">
        <header className="sticky top-0 z-30 bg-white border-b border-gray-200 shadow-sm">
          <div className="h-16 flex items-center justify-between px-4 lg:px-8">
            <button
              onClick={toggleSidebar}
              className="lg:hidden p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            
            <div className="flex-1" />
            
            <div className="flex items-center gap-4">
              <span className="text-sm text-gray-600 hidden sm:block">Selamat datang, {user?.name}</span>
            </div>
          </div>
        </header>
        
        <main className="p-4 lg:p-8">
          {children}
        </main>
      </div>
    </div>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={
          <PublicLayout>
            <Home />
          </PublicLayout>
        } />
        <Route path="/books" element={
          <PublicLayout>
            <Books />
          </PublicLayout>
        } />
        <Route path="/books/category/:category" element={
          <PublicLayout>
            <Books />
          </PublicLayout>
        } />
        <Route path="/books/:id" element={
          <PublicLayout>
            <BookDetail />
          </PublicLayout>
        } />
        <Route path="/news" element={
          <PublicLayout>
            <NewsPageWrapper />
          </PublicLayout>
        } />
        <Route path="/news/:category" element={
          <PublicLayout>
            <NewsPageWrapper />
          </PublicLayout>
        } />
        <Route path="/news/read/:id" element={
          <PublicLayout>
            <NewsDetail />
          </PublicLayout>
        } />
        <Route path="/information" element={
          <PublicLayout>
            <Information />
          </PublicLayout>
        } />
        <Route path="/tentang-kami" element={
          <PublicLayout>
            <TentangKami />
          </PublicLayout>
        } />
        <Route path="/faq" element={
          <PublicLayout>
            <FAQ />
          </PublicLayout>
        } />
        <Route path="/hubungi-kami" element={
          <PublicLayout>
            <HubungiKami />
          </PublicLayout>
        } />
        <Route path="/login" element={
          <PublicLayout>
            <Login />
          </PublicLayout>
        } />
        
        {/* Admin Routes */}
        <Route path="/admin" element={
          <AdminLayout>
            <AdminDashboard />
          </AdminLayout>
        } />
        <Route path="/admin/books" element={
          <AdminLayout>
            <BookManagement />
          </AdminLayout>
        } />
        <Route path="/admin/news" element={
          <AdminLayout>
            <NewsManagement />
          </AdminLayout>
        } />
        <Route path="/admin/information" element={
          <AdminLayout>
            <InformationManagement />
          </AdminLayout>
        } />
        <Route path="/admin/about" element={
          <AdminLayout>
            <ManajemenTentangKami />
          </AdminLayout>
        } />
        <Route path="/admin/faqs" element={
          <AdminLayout>
            <ManajemenFAQ />
          </AdminLayout>
        } />
        <Route path="/admin/support-logos" element={
          <AdminLayout>
            <ManajemenSupportLogo />
          </AdminLayout>
        } />
      </Routes>
    </Router>
  );
}

export default App;
